module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/white-0.98-7540f1eb43ef2bf35db615373c050e2e.png";